import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';

interface Body {
  organizacao: string;
  login: string;
  senha: string;
}

export default function criptografar(body: Body): string {
  try {
    if (body) {
      // Converta o objeto para uma string JSON
      const jsonString = JSON.stringify(body);

      // Criptografe a string JSON usando AES
      const encrypted = CryptoJS.AES.encrypt(
        jsonString,
        environment.encryptSecretKey
      ).toString();

      return encrypted;
    } else {
      return '';
    }
  } catch (err) {
    console.error('Erro ao criptografar:', err);
    return '';
  }
}
